export const LADDER_TYPE_CONFIG = {
    GROUP_1: {
        keywords: ['nmu', 'sf', 'chu', 'mu'],
        models: {
            2: 'ladder3.glb',
            3: 'ladder3.glb',
            4: 'ladder4.glb',
            5: 'ladder5.glb'
        }
    },
    GROUP_2: {
        keywords: ['nsl', 'sl', 'ms', 'sp'],
        models: {
            2: 'ladder6.glb',
            3: 'ladder6.glb',
            4: 'ladder8.glb',
            5: 'ladder10.glb'
        }
    }
};

export const LADDER_HEIGHT_CONFIG = {
    'ladder2.glb': { baseHeight: -0.15, depthCoefficient: 0.72 },
    'ladder3.glb': { baseHeight: -0.025, depthCoefficient: -0.99 },
    'ladder4.glb': { baseHeight: 0.1, depthCoefficient: -0.81 },
    'ladder5.glb': { baseHeight: 0.225, depthCoefficient: -0.34 },
    'ladder6.glb': { baseHeight: -0.056, depthCoefficient: -0.97 },
    'ladder8.glb': { baseHeight: 0.1, depthCoefficient: -0.77 },
    'ladder10.glb': { baseHeight: 0.18, depthCoefficient: -0.34 },
    'ladder12.glb': { baseHeight: 0.1, depthCoefficient: -0.795 }
};

export const LADDER_POSITIONING_CONFIG = {
    xOffset: 0.9,
    zOffset: 0.775,
    yOffset: -1.58,

    widthCoefficient: 0.23,
    lengthCoefficient: 0.1938,

    poolTypes: {
        'скиммерный': { yOffset: -1.58 },
        'переливной': { yOffset: -1.54 }
    }
};

export const LADDER_MODEL_CONFIG = {
    SCALE: [1.0, 1.0, 1.0],
    INDIVIDUAL_SCALES: {
        'ladder2.glb': [0.8, 0.8, 0.8],
        'ladder3.glb': [0.8, 0.8, 0.8],
        'ladder4.glb': [0.8, 0.8, 0.8],
        'ladder5.glb': [0.8, 0.8, 0.8],
        'ladder6.glb': [0.8, 0.8, 0.8],
        'ladder8.glb': [0.8, 0.8, 0.8],
        'ladder10.glb': [0.8, 0.8, 0.8],
        'ladder12.glb': [0.8, 0.8, 0.8]
    },
    DIMENSIONS: {
        WIDTH: 0.6,
        HEIGHT: 1.2,
        DEPTH: 0.4
    },
    INSTALLATION_HEIGHT: 0.1
};


export const LADDER_PATTERNS = [
    /(\d+)\s*ступен/i,
    /(\d+)\s*ступ/i,
    /ступен[ей]?\s*(\d+)/i,
    /ступ[ей]?\s*(\d+)/i,
    /(\d+)\s*step/i,
    /step\s*(\d+)/i,
    /(\d+)\s*stufe/i,
    /stufe\s*(\d+)/i
];

export const LADDER_CONSTANTS = {
    TOOLTIP: {
        x: 0,
        y: 1.5,
        z: 0
    }
};
